export enum FieldsName {
  releaseLink = 'releaseLink',
}

export type FieldsType = {
  [FieldsName.releaseLink]: string;
};
